import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import {CREATE_SUPERVISOR, DELETE_SUPERVISOR, GET_PROJET, VALET_LIST, ALL_VALET_LIST_DATA, ALL_SUPERVISOR_LIST_DATA, UPDATE_SUPERVISOR_LIST_DATA, UPDATE_VALET_LIST_DATA, ATTENDANCE_REQUEST_LIST, GET_ALL_DAYS, VALET_ATTENDANCE_REQUEST, ALL_VALET_USERS} from "./type";

export const createSupervisor = (requestParams) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.post,
            {
                'phone_number': requestParams.phone_no,
                'first_name': requestParams.first_name,
                'last_name': requestParams.last_name,
                'project_id': requestParams.project_id,
            },
            `${Config.valet.supervisor}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: CREATE_SUPERVISOR,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: CREATE_SUPERVISOR,
            payload: null,
        });
        return true;
    }
}

export const supervisorList = (data) => async (dispatch) => {
    // console.log(data);
    dispatch({
        type: GET_PROJET,
        payload: null,
    });
    const res = await callWebService(
          callTypes.post,
          data,
          Config.valet.supervisorList
        );
        // console.log(res); return false;
        if (res) {
          const { data } = res;
          dispatch({ type: GET_PROJET, payload: data.response.data });
          return data.response.data;
        }
}
export const valetList = (data) => async (dispatch) => {
    console.log(data);
    dispatch({
        type: VALET_LIST,
        payload: null,
    });
    const res = await callWebService(
          callTypes.post,
          data,
          Config.valet.valetList
        );
        
        if (res) {
          const { data } = res;
          dispatch({ type: VALET_LIST, payload: data.response.data });
          return data.response.data;
        }
}

/**
 *
 * @param requestParams
 * @returns {(function(*): Promise<*|boolean|undefined>)|*}
 */
export const deleteSupervisor = (requestParams) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.post,
            {
                'user_id': requestParams.user_id,
                'project_id': requestParams.project_id,
            },
            `${Config.valet.deleteSupervisor}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: DELETE_SUPERVISOR,
                payload: data,
            });
            return res;
        }
    }
    catch {
        dispatch({
            type: DELETE_SUPERVISOR,
            payload: null,
        });
        return true;
    }
}


export const getValetListData = (filterData = null, page = 1) => async (
    dispatch
  ) => {
    dispatch({
      type: ALL_VALET_LIST_DATA,
      payload: null,
    });
    let queryString = `${Config.valet.getValetListData}?page=${page}`;

    if (filterData) {
      if (filterData.project_id) {
        queryString += `&project_id=${filterData.project_id}`;
      }
      if (filterData.user_id) {
        queryString += `&user_id=${filterData.user_id}`;
      }
      if (filterData.user_name) {
        queryString += `&user_name=${filterData.user_name}`;
      }
      if (filterData.phone_number) {
        queryString += `&phone_number=${filterData.phone_number}`;
      }
    }
    const res = await callWebService(
      callTypes.get,
      '',
      queryString
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: ALL_VALET_LIST_DATA,
        payload: data.response.data,
      });
      return true;
    }
  };


export const getSupervisorListData = (filterData = null, page = 1) => async (
    dispatch
  ) => {
    dispatch({
      type: ALL_SUPERVISOR_LIST_DATA,
      payload: null,
    });
    let queryString = `${Config.valet.getSupervisorListData}?page=${page}`;

    if (filterData) {
      if (filterData.project_id) {
        queryString += `&project_id=${filterData.project_id}`;
      }
      if (filterData.user_id) {
        queryString += `&user_id=${filterData.user_id}`;
      }
      if (filterData.user_name) {
        queryString += `&user_name=${filterData.user_name}`;
      }
      if (filterData.phone_number) {
        queryString += `&phone_number=${filterData.phone_number}`;
      }
    }

    const res = await callWebService(
      callTypes.get,
      '',
      queryString
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: ALL_SUPERVISOR_LIST_DATA,
        payload: data.response.data,
      });
      return true;
    }
  };

export const updateSupervisorListData = (data) => async (dispatch) => {
    // console.log(data);
    dispatch({
        type: UPDATE_SUPERVISOR_LIST_DATA,
        payload: null,
    });
    const res = await callWebService(
          callTypes.post,
          data,
          Config.valet.updateSupervisorListData
        );
        
        if (res) {
          const { data } = res;
          dispatch({ type: UPDATE_SUPERVISOR_LIST_DATA, payload: data.response.data });
          return data.response.data;
        }
}

export const updateValetListData = (data) => async (dispatch) => {
    // console.log(data);
    dispatch({
        type: UPDATE_VALET_LIST_DATA,
        payload: null,
    });
    const res = await callWebService(
          callTypes.post,
          data,
          Config.valet.updateValetListData
        );
        
        if (res) {
          const { data } = res;
          dispatch({ type: UPDATE_VALET_LIST_DATA, payload: data.response.data });
          return data.response.data;
        }
}

export const fetchAttendanceRequests = (requestParams) => async (dispatch) => {
  dispatch({
      type: ATTENDANCE_REQUEST_LIST,
      payload: null,
  });
  const res = await callWebService(
        callTypes.get,
        '',
        `${Config.valet.fetchAttendanceRequests}`
      );
      if (res) {
        const { data } = res;
        dispatch({ type: ATTENDANCE_REQUEST_LIST, payload: data.response.data });
        return data.response.data;
      }
}

export const getDaysData = (data = {}) => async (dispatch) => {
  const queryParams = new URLSearchParams(data).toString();
  const fullUrl = `${Config.valet.getAllDays}?${queryParams}`;

  const res = await callWebService(
    callTypes.get,
    null,
    fullUrl
  );

  if (res) {
    const { data } = res;
    dispatch({
      type: GET_ALL_DAYS,
      payload: data.response,
    });
    return true;
  }
};

export const valetAttendanceRequest = (requestParams) => async (dispatch) => {
  try {
      const res = await callWebService(
          callTypes.post,
          requestParams,
          `${Config.valet.valetAttendanceRequest}`
      );

      if (res) {
          const { data } = res;
          dispatch({
              type: VALET_ATTENDANCE_REQUEST,
              payload: data,
          });
          return data;
      }
  }
  catch {
      dispatch({
          type: VALET_ATTENDANCE_REQUEST,
          payload: null,
      });
      return true;
  }
}

// export const allValetUsers = () => async (dispatch) => {
//   const res = await callWebService(
//       callTypes.get,
//       '',
//       `${Config.valet.allValetUsers}`
//   );
//   if (res) {
//       const { data } = res;
//       dispatch({
//           type: ALL_VALET_USERS,
//           payload: data.response,
//       });
//       return true;
//   }
// };

export const allValetUsers = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.valet.allValetUsers}`
  );

  if (res) {
    const { data } = res;

    dispatch({
      type: ALL_VALET_USERS,
      payload: data.response,
    });

    return data.response;
  }

  return null;
};